export default {
	noEvents: "Ningún evento encontrado",
	noEventsDescription: "No hay eventos para mostrar en esta línea de tiempo",
};
